<template>
  <div class="custom-menu-tree">
    <!--    <template v-for="item in dataList">-->
    <!--      <el-submenu v-if="item.level" :key="item.id" :index="item.id + ''"-->
    <!--                  :class="isshowClass&&item.level>3?'threeMenu':''">-->
    <!--        <template slot="title" :style="{color: String(departmentId) === String(item.id) ? '#158fcf': ''}">-->
    <!--          <span :style="{color: String(departmentId) === String(item.id) ? '#158fcf': ''}">{{ item.name }} </span>-->
    <!--        </template>-->

    <!--        <MenuTree v-if="item.children" :departmentId="departmentId" :dataList="item.children"-->
    <!--                  :isshowClass="true">-->
    <!--        </MenuTree>-->
    <!--      </el-submenu>-->
    <!--      <el-menu-item v-if="!item.level" :key="item.id" :index="item.id+''">-->
    <!--        <template slot="title" :style="{color: String(departmentId) === String(item.id) ? '#158fcf': ''}">-->
    <!--          <span :style="{color: String(departmentId) === String(item.id) ? '#158fcf': ''}">{{ item.name }} </span>-->
    <!--        </template>-->
    <!--      </el-menu-item>-->
    <!--    </template>-->
    <div v-for="(element) of dataList" :key="element.id">
      <div style="display: flex;justify-content: space-between;">
<!--        <el-checkbox v-if="element.level==2" v-model="element.checked" @change="changeCheck"-->
<!--                     style="margin: 5px 0;"></el-checkbox>-->
        <el-submenu v-if="element.level"
                    :index="element.id+''" :key="element.id" :class="isshowClass  && element.level>3?'threeMenu':''">
          <template slot="title" :style="{color: String(departmentId) === String(element.id) ? '#158fcf': ''}">
          <span :style="{color: String(departmentId) === String(element.id) ? '#158fcf': ''}">
             {{ element.name }}
           </span>
          </template>
          <MenuTree :dataList="element.children" :departmentId="departmentId" :isshowClass="true"></MenuTree>
        </el-submenu>
        <el-menu-item v-else-if="!element.level"
                      :key="element.id" :index="element.id+''" :class="isshowClass ? 'itemSty':''">
          <template slot="title"
                    :style="{color: String(departmentId) === String(element.id) ? '#158fcf': ''}">
            <span :style="{color: String(departmentId) === String(element.id) ? '#158fcf': ''}"> {{
                element.name
              }} </span>
          </template>
        </el-menu-item>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "MenuTree",
  props: ['dataList', 'departmentId', 'isshowClass'],
  // created() {
  //
  //
  // },
  watch: {

  },
  methods: {
    changeCheck(val){
      this.$emit('changeCheck',val)
    }
  }
}
</script>

<style lang="stylus" scoped>

.threeMenu {
  padding-left: 20px !important;
  .itemSty {
    left: -25px
  }
}

/deep/.el-submenu ,.is-opened{
  width: 150px!important
}

</style>
